import { getPrincipal } from 'src/utils/auth';
/* eslint-disable prefer-const */
import moment from 'moment';
import _ from 'lodash';
import { env } from 'src/env';
const APIURL = env.REACT_APP_API_HOST;
const FILESIZE = env.REACT_APP_FILE_SIZE;
const IMAGEFILESIZE = env.REACT_APP_IMAGE_FILE_SIZE;

/**
  Remove Tag
**/
export const removeTag = (textWithTag: string) => textWithTag.replace(/(<([^>]+)>)/gi, '');

/**
  Remove Special Char
**/
export const removeSpecialChar = (textWithTag: string) => textWithTag.replace(/&nbsp;/gi, '');

/**
  Set Local Storage
**/
export const setLocalStorage = (obj: { key: string; value: string }) => {
  localStorage.setItem(obj.key, obj.value);
};

/**
  Get Local Storage
**/
export const getLocalStorage = (obj: { key: string }) => {
  return localStorage.getItem(obj.key);
};
/**
  Remove Local Storage
**/
export const removeLocalStorage = (obj: { key: string }) => {
  return localStorage.removeItem(obj.key);
};

/**
  Remove All Tag
**/
export const removeAllTag = (textWithTag: string) => {
  let retValue = '';
  retValue = textWithTag.replace(/(<([^>]+)>)/gi, '');
  retValue = retValue.replace(/&nbsp;/gi, '');
  retValue = retValue.trim();
  return retValue;
};

/**
  Get Storage: Member Info
**/
export const getMemberInfo = () => {
  const principal = getPrincipal();
  if (!principal) return {};
  const review = JSON.parse(sessionStorage.getItem('review_user') || 'null');
  const current: any = review ? { ...principal, ...review } : principal;
  const { cust_cd, ...member } = current;
  return { ...member, acct_year: principal.login_year,
    ...(principal.schema !== 'public' ? { cust_cd } : {}) };
};

/**
  Get Storage: Member Info
**/
export const checkAdminRole = () => {
  let retFlag = false;
  const memberInfo: any = getMemberInfo();
  const roles = memberInfo.roles || [];
  const adminRole = roles.find((role: string) => role === 'ROLE_ADMIN');
  if (adminRole) retFlag = true;
  return retFlag;
};

/**
  GET Location Info
**/
export const getLocationParameter = (param: string) => {
  let params = new URL(document.location + '').searchParams;
  return params.get(param);
};

/**
  GET Current Time
**/
export const currentTimeChatForm = () => {
  const timestamp = moment().format('HH:mm ss');
  return timestamp;
};

/**
  GET Current Time(UUID)
**/
export const currentUUID = () => {
  const timestamp = moment().format('x');
  return timestamp;
};
/**
  GET Current Time(UUID)
**/
export const ldUUID = () => {
  const uuid = _.uniqueId();
  return uuid;
};

/**
  Link
**/
export const linkUrl = (url: string, type?: string) => {
  if (type === 'blank') {
    const openWindow: any = window.open('about:blank');
    openWindow.location.href = url;
  } else {
    window.location.href = url;
  }
};

/**
  addComma
**/
export const addComma = (num: number) => {
  if (typeof num !== 'number') return num;
  const retNum = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return retNum;
};

/**
  removeComma
**/
export const removeComma = (num: number) => {
  if (typeof num === 'number') return num;
  // const retNum = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // return retNum;
};

/**
  image extention check
**/
export const imageExtentionCheck = (fileName: string, setModalState: any) => {
  const imageExtensions = [
    'jpeg',
    'jpg',
    'gif',
    'png',
    'tiff',
    'bmp',
    'webp',
    'svg',
    'ico',
    'heic',
  ];
  const fileExtension = fileName.split('.').pop()?.toLowerCase();
  if (!fileExtension || !imageExtensions.includes(fileExtension)) {
    const resError = {
      mainTitle: '유효하지 않은 이미지 파일 확장자입니다.',
      subTitle: '사용 가능한 확장자 : jpeg, jpg, gif, png, tiff, bmp, webp, svg, ico, heic',
    };
    setModalState({ data: resError, active: '_active' });
    return false;
  }
  return true;
};

/**
  Convert bas64 to file
**/
export const dataURLtoFile = (dataurl: any) => {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n: number = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  const fileName = currentUUID() + '.jpeg';
  return new File([u8arr], fileName, { type: mime });
};
/**
  Convert file to bas64
**/
export const toBase64 = (file: any) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    return reader.result;
  });

/**
  Set Local Storage
**/
export const getImageSrc = (imgUrl: string) => {
  return APIURL + imgUrl;
};

/**
  Data Sort (desc)
**/
export const setDateSortDesc = <T extends Record<string, any>>(data: T[], field: string): T[] => {
  return [...data].sort((a, b) => {
    const valueA = new Date(a[field]).getTime();
    const valueB = new Date(b[field]).getTime();
    return valueB - valueA; // 내림차순 정렬
  });
};

/**
  Data Sort (desc)
**/
export const setSortDesc = (data: any, field: string) => {
  const sortedData = data.sort((a: any, b: any) => a[field] - b[field]).reverse();
  return sortedData;
};

/**
  Average
**/
export const avgArrayValue = (data: any) => {
  let avgValue = data.reduce((acc: any, curr: any) => acc + curr, 0) / data.length;
  return avgValue;
};

/**
  check number
**/
export const checkNegative = (num: number) => {
  let retStr = '';
  if (num > 0) retStr = 'add';
  if (num < 0) retStr = 'minus';
  return retStr;
};

/**
  Attach file size check
**/
export const fileSizeCheck = (file: File, setModalState: any) => {
  if (file.size > FILESIZE) {
    const resError = {
      mainTitle: `파일 크기가 초과했습니다.`,
      subTitle: `(${file.size} bytes)`,
    };
    setModalState({ data: resError, active: '_active' });
    return false;
  }
  return true;
};

/**
  image file size check
**/
export const imageSizeCheck = (file: File, setModalState: any) => {
  if (file.size > IMAGEFILESIZE) {
    const resError = {
      mainTitle: `이미지 파일 크기가 초과했습니다.`,
      subTitle: `(${file.size} bytes)`,
    };
    setModalState({ data: resError, active: '_active' });
    return false;
  }
  return true;
};

/**
  GET Current Time
**/
export const currentTimeFormat = (format = 'YYYY.MM.DD') => {
  const timestamp = moment().format(format);
  return timestamp;
};

/**
  GET Current Time
**/
export const dateFormat = (dateStr: string, dateForm?: string) => {
  if (!dateForm) dateForm = 'YYYY MM.DD';
  let dateSet = '';
  if (dateStr && dateStr !== '') dateSet = moment(dateStr).format(dateForm);
  return dateSet;
};
